export class DialogReverify{
    constructor(
      public data: any
    ) {}
  }
  